module.exports = __webpack_public_path__ + "static/media/Hydra.3f7646a7.png";